<template>
  <div class="tournament-content-tab tab-devices" v-bind:class="{'tournament-content-active-tab':activeTab == 13}">

    <!-- Шапка -->
    <section class="adm-panel adm-head">
      <h3 class="adm-title">
        <tkd-icon name="referee"/> Електронна система
        <span class="adm-count">{{ events.length }}</span>
      </h3>
      <div class="dev-actions">
        <span class="dev-status" :class="'is-' + status" role="status">
          <span class="dev-dot" aria-hidden="true"></span>{{ statusText }}
        </span>
        <button type="button" class="adm-btn adm-btn-sm" @click="paused = !paused" :aria-pressed="paused ? 'true' : 'false'">
          {{ paused ? '▶ Продовжити' : '⏸ Пауза' }}
        </button>
        <button type="button" class="adm-btn adm-btn-sm" @click="fetchEvents()" :disabled="loading">
          <tkd-icon name="refresh"/> Оновити
        </button>
      </div>
    </section>

    <!-- Куди пристрої шлють дані: формат поки невідомий, сервер має зберігати запит як є -->
    <section class="adm-panel dev-info">
      <p>
        Тут зʼявляються всі повідомлення від електронних пристроїв (табло, жилети, суддівські пульти) — без обробки, як прийшли.
        Формат ще невідомий, тому показуємо сирі дані: метод, параметри і тіло запиту.
      </p>
      <div class="dev-url">
        <span class="adm-label">Адреса для пристроїв (GET або POST)</span>
        <code>{{ deviceUrl }}</code>
        <button type="button" class="adm-btn adm-btn-sm adm-btn-ghost" @click="copy(deviceUrl)"><tkd-icon name="copy"/> Копіювати</button>
      </div>
    </section>

    <div class="adm-panel dev-toolbar" v-if="events.length">
      <input type="search" class="adm-input dev-search" v-model="search" placeholder="Пошук у повідомленнях" aria-label="Пошук у повідомленнях">
      <span class="dev-shown">Показано {{ visibleEvents.length }} з {{ events.length }}</span>
    </div>

    <!-- Список повідомлень: новіші зверху -->
    <ol class="dev-list" v-if="visibleEvents.length">
      <li class="dev-item" v-for="e in visibleEvents" :key="e.key">
        <header class="dev-item-head">
          <span class="adm-chip strong" v-if="e.method">{{ e.method }}</span>
          <span class="adm-chip" v-if="e.device">{{ e.device }}</span>
          <span class="dev-time">{{ e.time || 'час невідомий' }}</span>
          <button type="button" class="adm-btn adm-btn-sm adm-btn-ghost dev-copy" @click="copy(e.text)"><tkd-icon name="copy"/> Копіювати</button>
        </header>
        <textarea class="dev-raw" readonly :rows="e.rows" :value="e.text" aria-label="Дані повідомлення"></textarea>
      </li>
    </ol>

    <section class="adm-empty" v-else-if="!events.length">
      <div class="adm-empty-icon" aria-hidden="true"><tkd-icon name="referee"/></div>
      <p v-if="status === 'unavailable'">Сервер ще не віддає повідомлення пристроїв</p>
      <p v-else-if="status === 'error'">Не вдалося отримати повідомлення</p>
      <p v-else>Повідомлень від пристроїв ще немає</p>
      <small>{{ status === 'unavailable' ? 'Потрібен ендпоінт ' + listUrl : 'Сторінка оновлюється кожні ' + (POLL_MS / 1000) + ' с.' }}</small>
    </section>

    <section class="adm-empty" v-else>
      <div class="adm-empty-icon" aria-hidden="true"><tkd-icon name="search"/></div>
      <p>Нічого не знайдено</p>
    </section>
  </div>
</template>

<script>
  import axios from 'axios';
  import {baseUrlServer} from 'src/api/user.js';
  import 'src/assets/css/tkd-theme.css';
  import 'src/assets/css/tkd-admin.css';

  // Бекенд (модуль electronic-system, FightResultController):
  //  1) DEVICE_PATH приймає від пристроїв будь-який GET/POST/PUT з ключем доступу і кодом турніру (tournament.code) і зберігає запит як є;
  //  2) LIST_PATH?tournament_id=… віддає останні запити турніру ({data: {items: [...]}}, старіші першими).
  const DEVICE_PATH = '/electronic-system/fight-result/receive';
  const LIST_PATH = '/electronic-system/fight-result/list';
  const POLL_MS = 5000;

  export default {
    name: "tab-devices",
    data() {
      return {
        POLL_MS,
        rawEvents: [],
        search: '',
        paused: false,
        loading: false,
        // idle | ok | unavailable | error
        status: 'idle',
        lastUpdate: '',
        timer: null,
      }
    },
    computed: {
      activeTab() {
        return this.$store.getters['settings/activeTournamentTab'];
      },
      tournamentOne() {
        return this.$store.getters['tournament/tournamentOne'];
      },
      tournamentId() {
        return this.tournamentOne && this.tournamentOne.data && this.tournamentOne.data.item ? this.tournamentOne.data.item.id : null;
      },
      tournamentCode() {
        return this.tournamentOne && this.tournamentOne.data && this.tournamentOne.data.item ? this.tournamentOne.data.item.code : null;
      },
      // ключ доступу знає тільки адміністратор, у фронтенд його не кладемо
      deviceUrl() {
        if (!this.tournamentCode) {
          return 'У турніру ще немає коду — пристрої не зможуть надсилати дані';
        }
        return baseUrlServer + DEVICE_PATH + '?code=' + this.tournamentCode + '&access_key=КЛЮЧ_ДОСТУПУ';
      },
      listUrl() {
        return baseUrlServer + LIST_PATH;
      },
      statusText() {
        if (this.paused) return 'На паузі';
        if (this.status === 'ok') return 'Оновлено о ' + this.lastUpdate;
        if (this.status === 'unavailable') return 'Сервер ще не готовий';
        if (this.status === 'error') return 'Помилка звʼязку';
        return 'Очікування…';
      },
      // нормалізуємо будь-яку форму: відомі поля — в шапку, решта — сирим текстом
      events() {
        return this.rawEvents.map((item, index) => {
          const obj = item && typeof item === 'object' ? item : null;
          const pick = (...keys) => obj ? keys.map(k => obj[k]).find(v => v !== undefined && v !== null && v !== '') : undefined;
          const text = this.pretty(item);
          return {
            key: (pick('id') || 'i') + '_' + index,
            method: pick('method', 'http_method'),
            device: pick('device', 'device_id', 'source'),
            time: pick('created_at', 'received_at', 'time', 'timestamp'),
            text,
            rows: Math.min(18, Math.max(3, text.split('\n').length)),
          };
        }).reverse();
      },
      visibleEvents() {
        const query = this.search.trim().toLowerCase();
        if (!query) return this.events;
        return this.events.filter(e => e.text.toLowerCase().includes(query));
      },
      // опитуємо сервер лише коли вкладка відкрита
      shouldPoll() {
        return this.activeTab == 13 && !this.paused && !!this.tournamentId;
      },
    },
    watch: {
      shouldPoll: {
        immediate: true,
        handler(value) {
          this.stopPolling();
          if (value) {
            this.fetchEvents();
            this.timer = setInterval(() => this.fetchEvents(), POLL_MS);
          }
        },
      },
    },
    beforeDestroy() {
      this.stopPolling();
    },
    methods: {
      stopPolling() {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      },
      fetchEvents() {
        if (!this.tournamentId || this.loading) return;
        this.loading = true;
        axios.get(this.listUrl, {params: {tournament_id: this.tournamentId}})
          .then(res => {
            const data = res.data;
            const list = Array.isArray(data) ? data
              : data && Array.isArray(data.items) ? data.items
              : data && data.data && Array.isArray(data.data.items) ? data.data.items
              : data && Array.isArray(data.data) ? data.data
              : [];
            this.rawEvents = list;
            this.status = 'ok';
            this.lastUpdate = new Date().toLocaleTimeString('uk-UA', {hour: '2-digit', minute: '2-digit', second: '2-digit'});
          })
          .catch(err => {
            const code = err && err.response && err.response.status;
            // ендпоінта ще немає — не спамимо запитами
            if (code === 404 || code === 405) {
              this.status = 'unavailable';
              this.stopPolling();
            } else {
              this.status = 'error';
            }
          })
          .finally(() => { this.loading = false; });
      },
      // JSON — з відступами; рядок з JSON всередині (body) — теж розгортаємо
      pretty(value) {
        if (typeof value === 'string') {
          try {
            return JSON.stringify(JSON.parse(value), null, 2);
          } catch (e) {
            return value;
          }
        }
        try {
          const copy = value && typeof value === 'object' ? Object.assign({}, value) : value;
          if (copy && typeof copy.body === 'string') {
            try { copy.body = JSON.parse(copy.body); } catch (e) { /* лишаємо як є */ }
          }
          return JSON.stringify(copy, null, 2);
        } catch (e) {
          return String(value);
        }
      },
      copy(text) {
        const done = () => this.$notify({text: 'Скопійовано', type: 'success', duration: 1500});
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(done).catch(() => {});
        }
      },
    },
  }
</script>

<style scoped>
.tab-devices {
  font-family: var(--tkd-font);
  color: var(--tkd-text);
}

.dev-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.dev-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: var(--tkd-muted);
}

.dev-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--tkd-border);
}

.dev-status.is-ok .dev-dot {
  background: var(--adm-ok-strong);
  animation: dev-pulse 2s ease-in-out infinite;
}

.dev-status.is-unavailable .dev-dot { background: var(--adm-warn-strong); }
.dev-status.is-error .dev-dot { background: var(--adm-danger); }

@keyframes dev-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: .35; }
}

.dev-info p {
  margin: 0 0 12px;
  font-size: 14px;
  color: var(--tkd-muted);
}

.dev-url {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.dev-url .adm-label {
  flex-basis: 100%;
  margin: 0;
}

.dev-url code {
  padding: 6px 10px;
  border: 1px solid var(--tkd-border);
  border-radius: var(--tkd-radius);
  background: var(--tkd-bg);
  font-size: 13px;
  color: var(--tkd-navy);
  overflow-wrap: anywhere;
}

.dev-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.dev-search {
  flex: 1 1 240px;
  max-width: 360px;
}

.dev-shown {
  font-size: 13px;
  color: var(--tkd-muted);
}

.dev-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 0 0 16px;
  padding: 0;
  list-style: none;
}

.dev-item {
  padding: 12px 14px;
  background: var(--tkd-surface);
  border: 1px solid var(--tkd-border);
  border-left: 4px solid var(--tkd-blue);
  border-radius: var(--tkd-radius);
  box-shadow: var(--tkd-shadow);
}

.dev-item-head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.dev-time {
  font-size: 13px;
  font-weight: 600;
  color: var(--tkd-muted);
}

.dev-copy { margin-left: auto; }

.dev-raw {
  display: block;
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--tkd-border);
  border-radius: var(--tkd-radius);
  background: var(--tkd-bg);
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 12.5px;
  line-height: 1.5;
  color: var(--tkd-text);
  resize: vertical;
}

.dev-raw:focus-visible {
  outline: none;
  border-color: var(--tkd-blue);
  box-shadow: 0 0 0 4px rgba(0, 87, 183, .12);
}

.adm-empty small {
  font-size: 13px;
  overflow-wrap: anywhere;
}

@media (max-width: 767px) {
  .dev-search { max-width: none; }
  .dev-copy { margin-left: 0; }
}

@media (prefers-reduced-motion: reduce) {
  .dev-status.is-ok .dev-dot { animation: none; }
}
</style>
